// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SSH_KEYS = {
    TABLE: 'sshKeys-table',
};

export const sshKeyTestId = (id: number | string, postfix: string) => `sshKey-${id}-${postfix}`;
